import { createLogger } from "logging";
import { useMeeting } from "providers";
import React, { PropsWithChildren, useCallback, useMemo, useState } from "react";

import { DocumentsPanel } from "./components/DocumentsPanel";
import { DocumentsPanelContext } from "./DocumentsPanelContext";

const logger = createLogger("DocumentsPanelProvider");

export const DocumentsPanelProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [agendaItemId, setAgendaItemId] = useState<number | null>(null);
  const { meeting, reloadMeeting, isLoading } = useMeeting();

  const agendaItem = useMemo(() => {
    const items = meeting?.agendaItems || [];
    logger.debug(`find agendaItems:=`, items);
    const item = items?.find((x) => x.id === agendaItemId);
    logger.debug(`agendaItem:=`, item);
    return item;
  }, [meeting, agendaItemId]);

  const openDocumentsPanel = useCallback((id: number) => {
    logger.debug("openDocumentsPanel(): ", id);
    setAgendaItemId(id);
    setIsOpen(true);
  }, []);

  const closeDocumentsPanel = useCallback(() => {
    logger.debug("closeDocumentsPanel(): ", agendaItemId);
    setIsOpen(false);
    setAgendaItemId(null);
    reloadMeeting();
  }, [agendaItemId, reloadMeeting]);

  const contextValue = useMemo(
    () => ({ isOpen, agendaItem, isLoading, reloadMeeting, openDocumentsPanel, closeDocumentsPanel }),
    [isOpen, agendaItem, isLoading, reloadMeeting, openDocumentsPanel, closeDocumentsPanel]
  );

  return (
    <DocumentsPanelContext.Provider value={contextValue}>
      {children}
      <DocumentsPanel />
    </DocumentsPanelContext.Provider>
  );
};
